import React from 'react';
import './Blogs.css'

const Blogs = () => {
  return (
    <div className='blogs_page'>
     <div className="container">
       <div className="row">
         <div className="col-md-8 offset-md-2">

         <article className='single_Blog'>
       <h2>1. Difference between authorization and authentication</h2>
       <div className="table-responsive">
       <table className="table table-bordered table-dark">
  <thead>
    <tr className='text-center table_content'>
      <th scope="col">#</th>
      <th scope="col">Authorization</th>
      <th scope="col">Authentication</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <th scope="row" className='table_content'>1</th>
      <td className='table_content'>In authentication process, the identity of users are checked for providing the access to the system.</td>
      <td className='table_content'>While in authorization process, person’s or user’s authorities are checked for accessing the resources.</td>
    </tr>

    <tr>
      <th scope="row" className='table_content'>2</th>
      <td className='table_content'>Authentication determines whether the person is user or not.</td>
      <td className='table_content'>While it determines What permission do user have?</td>
    </tr>

    <tr>
      <th scope="row" className='table_content'>3</th>
      <td className='table_content'>User can partially change the authentication details as per the requirement</td>
      <td className='table_content'>User cannot modify the Authorization permissions as it is given to a user by the owner/manager of the system, and only has the authority to change it.</td>
    </tr>

    <tr>
      <th scope="row" className='table_content'>4</th>
      <td className='table_content'>Data is available via Token IDs</td>
      <td className='table_content'>Data provided via Access token</td>
    </tr>

  </tbody>
</table>
       </div>
      </article>

         <article className='single_Blog'>
       <h2>2. Why are you using firebase? What other options do you have to implement authentication?</h2>
       <p>
       Google Firebase offers many features that pitch it as the go-to backend development tool for web and mobile apps. It reduces development workload and time. Firebase is simple, lightweight, friendly, and industrially recognized. <br /><br />
       We need to implement other options on authentication like sending email Verification email, Reset password email, Update profile, Sign In with popular social media, Phone number Verification.
       </p>
      </article>

         <article className='single_Blog'>
       <h2>3. What other services does firebase provide other than authentication?</h2>
       <p>  Interestingly, the Firebase platform is multifaceted, offering build tools and APIs around database management, authentication, push notifications, cloud hosting, and more.

Let's see some of its key features below.<br /><br />
       <b>1. Storage</b><br/>
Google Firebase uses dedicated cloud-based NoSQL databases, Firestore, and a real-time database, to store information.<br /><br/>

       <b>2. Hosting</b><br/>
       We can also host your web app easily on Firebase. <br /><br/>

       <b>3. Built-In Push Notifications</b><br/>
       Coding and implementing push notifications can be arduous. Firebase's built-in push notification lets we add personalized and real-time alert capabilities to our app without writing a separate script from scratch.
       
       </p>
      </article>


         </div>
       </div>
     </div>
    </div>
  );
};

export default Blogs;